var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "conversation-widget" } }, [
    _c("div", { staticClass: "custom-content" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", {
          staticClass: "closeBtn",
          on: {
            click: function ($event) {
              return _vm.closeChatHistory(false)
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [
        _vm.loading
          ? _c("div", { staticClass: "spinnerClass" }, [_c("a-spin")], 1)
          : _c("div", [_vm._m(1)], 1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("Sohbet Geçmişi")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("MessageList", {
      attrs: {
        "always-scroll-to-bottom": true,
        colors: _vm.colors,
        messages: _vm.messages,
        participants: _vm.participants,
      },
    })
  },
]
render._withStripped = true

export { render, staticRenderFns }